import React, { ReactNode, useContext, useEffect, useState } from 'react'
import CreationsFormPreview from './CreationsFormPreview'
import service from './services/creations-form.service'
import { CampaignFormContext, FormCreation } from 'contexts/CampaignFormContext'
import { Campaign, MediaFormat } from 'types/campaign'
import './CreationsForm.scss'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import { creationAcceptancesActions } from './store/creation-acceptances-slice'
import FormRow from '../../../../components/Form/FormRow'
import Select from '../../../../components/Form/Select'
import { useTranslation } from 'react-i18next'
import CampaignCreationsService from './services/campaign-creations.service'

const CreationsForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    creationsValues: creations,
    setCreationsValues: setCreations,
    triggerCreations,
    setTriggerCreations,
  } = useContext(CampaignFormContext)
  const [mediaFormats, setMediaFormats] = useState<MediaFormat[]>([])
  const { basicsValues, detailsValues } = useSelector((state: RootState) => state.campaignForm.form)
  const { creationContributionType } = useSelector((state: RootState) => state.campaignForm)
  const { loaded } = useSelector((state: RootState) => state.creationAcceptances)

  const { campaignId, startDate, endDate, status } = basicsValues

  useEffect(() => {
    if (campaignId) {
      service.getCreations(campaignId, creations, setCreations, setTriggerCreations)
    }
  }, [campaignId, triggerCreations])

  useEffect(() => {
    setMediaFormats([detailsValues.mediumFormat])
  }, [detailsValues.mediumFormat])

  useEffect(() => {
    // Reset state on unmount/destroy
    return () => {
      dispatch(creationAcceptancesActions.resetState())
    }
  }, [])

  return (
    <div className='CreationsForm'>
      <FormRow className='CreationsForm__row'>
        <Select
          id='creationContributionType'
          title={t('common.creationContributionType')}
          placeholder={t('common.creationContributionTypePlaceholder')}
          value={creationContributionType}
          onChange={(value: Campaign['creationContributionType']) => {
            void CampaignCreationsService.updateCampaignCreations(campaignId, value)
          }}
          options={[
            { value: 'absolute_value', label: t('form.campaign.basics.absoluteValue') },
            { value: 'percentage', label: t('form.campaign.basics.percentage') },
          ]}
        />
      </FormRow>

      {mediaFormats
        .sort((a, b) => a.localeCompare(b))
        .map(
          (mediaFormat: MediaFormat): ReactNode => (
            <CreationsFormPreview
              key={mediaFormat}
              campaignData={{
                id: campaignId,
                startDate,
                endDate,
                status,
                acceptanceStatus: detailsValues.acceptanceStatus,
                impressions: detailsValues.emissions,
                target: detailsValues.target,
                audience: detailsValues.audience,
                creationContributionType: detailsValues.creationContributionType,
              }}
              creations={creations.filter((c: FormCreation) => c.mediaFormat === mediaFormat)}
              mediaFormat={mediaFormat}
              acceptancesLoaded={loaded}
              creationContributionType={creationContributionType}
            />
          )
        )}
    </div>
  )
}

export default CreationsForm
